import {queryClient} from './queryClient';
import {IPresentationTheme} from '../incase-domain/presentationTheme';
import {QUERY_KEYS} from './queryKeys';

export function getPresentationThemeForEditor(themeId: string | undefined): IPresentationTheme {
    if (!themeId) {
        return {} as IPresentationTheme;
    }
    return queryClient.getQueryData<IPresentationTheme>(QUERY_KEYS.theme.detail(themeId)) ?? ({} as IPresentationTheme);
}
